// User-defined attributes: where the SETUP screen plugs into the runtime.
//
// The setup screen (Customize → Additional attributes: form, deciding columns,
// combinations, columns, column properties — plan §7.4) lives in
// ./designer/UdaSetupScreen. TxnScreen carries the entry points: the Customize
// bar's "Additional attributes" button, the field panel's "set up under
// Additional attributes" link and the `czUda` state that shows the screen in
// place of the list. Registering the component here turns them on (and the
// one `can-setup` request that decides whether they show).

import type { ComponentType } from 'react'
import type { TransactionModel } from '../txn/types'
import type { UdaLayer, UdaTransport } from './types'
import UdaSetupScreen from './designer/UdaSetupScreen'

export interface UdaSetupScreenProps {
  transport: UdaTransport
  objName: string
  /** Open on this form / column (from a field's ⚙ panel). */
  formNo?: string
  columnKey?: string
  onClose: () => void
  /** The transaction's model — its forms, their columns and lookups (the
   *  deciding columns' sources). The screen says so when it is missing. */
  model?: TransactionModel
  /** The host's project name (handed to the shared column editors). */
  project?: string
  /** `tenant` (default): an organization's draft → publish, through the
   *  transport. `design`: the transaction designer edits `layer`
   *  (`transaction.uda`) and gets every change through `onChange`; tenant_may
   *  chips and the additions switch show, publish and history do not. */
  mode?: 'tenant' | 'design'
  layer?: UdaLayer
  onChange?: (layer: UdaLayer) => void
  /** Design mode: open the transaction designer's OWN business-logic editor
   *  for a standard attribute's function (its item_change / validation
   *  method). A standard attribute's function is the transaction's business
   *  logic, so the setup screen hands off instead of editing it. Absent: the
   *  code dialog explains where to write it. */
  onOpenDesignerCode?: (method: string) => void
  /** A code editor the host provides (CodeMirror on the platform); a plain
   *  text area otherwise. */
  codeEditor?: ComponentType<{ value: string; onChange: (v: string) => void; language: string }>
}

export const UDA_SETUP_SCREEN: ComponentType<UdaSetupScreenProps> | null = UdaSetupScreen
